<template>
  <van-popup
    v-model="showPopup"
    class="tips-bottom-popup"
    position="bottom"
  >
    <div class="tips-bottom-popup-wrap">
      <div class="tips-bottom-popup-title">
        用券说明
        <img
          class="close-btn"
          src="@/assets/img/chargingVoucher/icon-bottom-popup-close.png"
          alt=""
          @click="showPopup = false"
        >
      </div>
      <div class="tips-bottom-popup-content">
        <!-- 小桔充电 服务费+电费通抵券 -->
        <div
          class="content"
          v-if="couponType === couponTypeOptions[1]"
        >
          1、下单后不支持退款及转让。<br>

          2、有效期1个月，过期自动失效，过期不补发不退款。<br>

          3、可抵扣【服务费和电费】。<br>

          4、单次充电限使用1张券。<br>

          5、卡券使用无金额门槛，建议充电费用超过卡券面额时使用，避免浪费。<br>

          6、买券时，请确保手机号为小桔的账号绑定的手机号，手机号错误将导致卡券无法使用。<br>

          7、本券可在小桔充电微信小程序、滴滴出行-充电频道、滴滴车主端-充电频道、小桔充电APP内使用。<br>

          8、有任何疑问，请致电：4000026862转6。<br>
        </div>
        <!-- 特来电 服务费抵扣券 -->
        <div
          class="content"
          v-else-if="couponType === couponTypeOptions[2]"
        >
          1、下单后不支持退款及转让。<br>

          2、有效期1个月，过期自动失效，过期不补发不退款。<br>

          3、充电券支持特来电直营充电场站使用（在特来电微信小程序查找标有"特来电权益"标签的场站)，支持抵扣【服务费】，不支持抵扣【电费】。<br>

          4、充电券购买成功后，无法进行修改及换绑手机号。<br>

          5、该券无使用充电订单金额门槛，且一笔充电订单可叠加使用多张特来电充电券。<br>

          6、买券时，请确保手机号是特来电的账号绑定的手机号，手机号错误将导致卡券无法使用。<br>

          7、本充电券支持在特来电微信小程序、特来电APP内使用。<br>

          对充电券的购买以及使用有疑问时，可拨打客服电话：4000026862转6。<br>
        </div>
        <!-- 特来电 服务费+电费通抵券 -->
        <div
          class="content"
          v-else-if="couponType === couponTypeOptions[3]"
        >
          1、下单后不支持退款及转让。<br>

          2、有效期1个月，过期自动失效，过期不补发不退款。<br>

          3、充电券支持特来电直营充电场站使用（在特来电微信小程序查找标有"特来电权益"标签的场站)，可抵扣【服务费和电费】。<br>

          4、充电券购买成功后，无法进行修改及换绑手机号。<br>

          5、该券无使用金额门槛，一笔充电订单可叠加使用多张特来电券。<br>

          6、买券时，请确保手机号是特来电的账号绑定的手机号，手机号错误将导致卡券无法使用。<br>

          7、本充电券支持在特来电微信小程序、特来电APP内使用。<br>

          8、对充电券的购买以及使用有疑问时，可拨打客服电话：4000026862转6。<br>
        </div>
        <!-- 星星充电 服务费抵扣券 -->
        <div
          class="content"
          v-else-if="couponType === couponTypeOptions[4]"
        >
          1、充电券购买后不得退款及转让。<br>

          2、充电券有效期为1个月，过期自动失效，且不补发不退款。<br>

          3、充电券支持星星直营和联营桩群充电场站使用，仅支持抵扣【服务费】。<br>

          4、充电券购买成功后，无法进行修改及换绑手机号。<br>

          5、该券无使用充电订单金额门槛，且一笔充电订单可叠加使用多张星星充电券。<br>

          6、本充电券支持在星星充电微信小程序、星星充电APP内使用。<br>

          7、该券无法与会员优惠同享。<br>

          8、对充电券的购买以及使用有疑问时，可拨打客服电话：4000026862转6。<br>
        </div>
        <!-- 星星充电 服务费+电费通抵券 -->
        <div
          class="content"
          v-else-if="couponType === couponTypeOptions[5]"
        >
          1、充电券购买后不得退款及转让。<br>

          2、充电券有效期为1个月，过期自动失效，且不补发不退款。<br>

          3、充电券支持星星直营和联营桩群充电场站使用，支持抵扣【服务费+电费】。<br>

          4、充电券购买成功后，无法进行修改及换绑手机号。<br>

          5、该券无使用充电订单金额门槛，且一笔充电订单可叠加使用多张星星充电券。<br>

          6、本充电券支持在星星充电微信小程序、星星充电APP内使用。<br>

          7、该券无法与会员优惠同享。<br>

          8、对充电券的购买以及使用有疑问时，可拨打客服电话：4000026862转6。<br>
        </div>
        <!-- 南方电网 服务费+电费通抵卡 -->
        <div
          class="content"
          v-else-if="couponType === couponTypeOptions[6]"
        >
          1、充电卡购买后不得退款及转让。<br>

          2、充电卡有效期为1个月，过期自动失效，且不补发不退款。<br>

          3、充电卡支持南网电动直营充电场站使用，支持抵扣【服务费+电费】。<br>

          4、充电卡购买成功后，无法进行修改及换绑手机号。<br>

          5、该卡无使用充电订单金额门槛，未使用完的余额可以下次使用。<br>

          6、本充电卡支持在顺易充微信小程序内使用。<br>

          7、该充电卡可与会员优惠同享。<br>

          8、对充电卡的购买以及使用有疑问时，可拨打客服电话：4000026862转6。<br>
        </div>
        <!-- 南方电网 服务费抵扣卡 -->
        <div
          class="content"
          v-else-if="couponType === couponTypeOptions[7]"
        >
          1、充电卡购买后不得退款及转让。<br>

          2、充电卡有效期为1个月，过期自动失效，且不补发不退款。<br>

          3、充电卡支持南网电动直营充电场站使用，支持抵扣【服务费】。<br>

          4、充电卡购买成功后，无法进行修改及换绑手机号。<br>

          5、该卡无使用充电订单金额门槛，未使用完的余额可以下次使用。<br>

          6、本充电卡支持在顺易充微信小程序内使用。<br>

          7、该充电卡可与会员优惠同享。<br>

          8、对充电卡的购买以及使用有疑问时，可拨打客服电话：4000026862转6。<br>
        </div>
        <!-- 南方电网 服务费抵扣券 -->
        <div
          class="content"
          v-else-if="couponType === couponTypeOptions[8]"
        >
          1、充电券购买后不得退款及转让。<br>

          2、充电券有效期为1个月，过期自动失效，且不补发不退款。<br>

          3、充电券支持南网电动充电场站使用，仅支持抵扣【服务费】。<br>

          4、充电券购买成功后，无法进行修改及换绑手机号。<br>

          5、该券为满减券，充电订单服务费金额达到门槛才可使用，且一笔充电订单只可使用一张充电券。<br>

          6、本充电券支持在顺易充微信小程序内使用。<br>

          7、该券可与会员以及充电卡优惠同享。<br>

          8、对充电券的购买以及使用有疑问时，可拨打客服电话：4000026862转6。<br>
        </div>
        <!-- 南方电网 会员卡（暂无） -->
        <!-- 云快充 服务费+电费通抵卡 -->
        <div
          class="content"
          v-else-if="couponType === couponTypeOptions[10]"
        >
          1、充电卡购买后不得退款及转让。<br>

          2、充电卡有效期为1个月，过期自动失效，且不补发不退款。<br>

          3、充电卡支持云快充直营充电场站使用，支持抵扣【服务费+电费】。<br>

          4、充电卡购买成功后，无法进行修改及换绑手机号。<br>

          5、该卡无使用充电订单金额门槛，未使用完的余额可以下次使用。<br>

          6、每笔充电订单仅可使用一张卡或者券，无法叠加使用。<br>

          7、本充电卡支持在云快充微信小程序或APP内使用。<br>

          8、对充电卡的购买以及使用有疑问时，可拨打客服电话：4000026862转6。<br>
        </div>
        <!-- 云快充 服务费抵扣卡 -->
        <div
          class="content"
          v-else-if="couponType === couponTypeOptions[11]"
        >
          1、充电卡购买后不得退款及转让。<br>

          2、充电卡有效期为1个月，过期自动失效，且不补发不退款。<br>

          3、充电卡支持云快充直营充电场站使用，支持抵扣【服务费】。<br>

          4、充电卡购买成功后，无法进行修改及换绑手机号。<br>

          5、该卡无使用充电订单金额门槛，未使用完的余额可以下次使用。<br>

          6、每笔充电订单仅可使用一张卡或者券，无法叠加使用。<br>

          7、本充电卡支持在云快充微信小程序或APP内使用。<br>

          8、对充电卡的购买以及使用有疑问时，可拨打客服电话：4000026862转6。<br>
        </div>
        <!-- 云快充 服务费+电费通抵券 -->
        <div
          class="content"
          v-else-if="couponType === couponTypeOptions[12]"
        >
          1、充电券购买后不得退款及转让。<br>

          2、充电券有效期为1个月，过期自动失效，且不补发不退款。<br>

          3、充电券支持云快充充电场站使用，仅支持抵扣【服务费+电费】。<br>

          4、充电券购买成功后，无法进行修改及换绑手机号。<br>

          5、该券为满减券，充电订单金额达到门槛才可使用。<br>

          6、每笔充电订单仅可使用一张卡或者券，无法叠加使用。<br>

          7、本充电券支持在云快充微信小程序或APP内使用。<br>

          8、对充电券的购买以及使用有疑问时，可拨打客服电话：4000026862转6。<br>
        </div>
        <!-- 云快充 服务费抵扣券 -->
        <div
          class="content"
          v-else-if="couponType === couponTypeOptions[13]"
        >
          1、充电券购买后不得退款及转让。<br>

          2、充电券有效期为1个月，过期自动失效，且不补发不退款。<br>

          3、充电券支持云快充充电场站使用，仅支持抵扣【服务费】。<br>

          4、充电券购买成功后，无法进行修改及换绑手机号。<br>

          5、该券为满减券，充电订单服务费金额达到门槛才可使用。<br>

          6、每笔充电订单仅可使用一张卡或者券，无法叠加使用。<br>

          7、本充电券支持在云快充微信小程序或APP内使用。<br>

          8、对充电券的购买以及使用有疑问时，可拨打客服电话：4000026862转6。<br>
        </div>
        <!-- 暂无说明 -->
        <div
          class="flex-center-center"
          v-else
        > 暂无说明 </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'TipsBottomPopup',
  data() {
    return {
      showPopup: false,
      couponType: '',
      couponTypeOptions: {
        // 小桔充电 服务费+电费通抵券
        1: 'XIAOJU_PAY_OFF',
        // 特来电 服务费抵扣券
        2: 'TELD_SERVICE_OFF',
        // 特来电 服务费+电费通抵券
        3: 'TELD_PAY_OFF',
        // 星星充电 服务费抵扣券
        4: 'STARCHARGE_SERVICE_OFF',
        // 星星充电 服务费+电费通抵券
        5: 'STARCHARGE_PAY_OFF',
        // 南方电网 服务费+电费通抵卡
        6: 'NWDD_PAY_OFF_CARD',
        // 南方电网 服务费抵扣卡
        7: 'NWDD_SERVICE_OFF_CARD',
        // 南方电网 服务费抵扣券
        8: 'NWDD_SERVICE_OFF',
        // 南方电网 会员卡
        9: 'NWDD_MEMBER_CARD',
        // 云快充 服务费+电费通抵卡
        10: 'JSYKC_PAY_OFF_CARD',
        // 云快充 服务费抵扣卡
        11: 'JSYKC_SERVICE_OFF_CARD',
        // 云快充 服务费+电费通抵券
        12: 'JSYKC_PAY_OFF',
        // 云快充 服务费抵扣券
        13: 'JSYKC_SERVICE_OFF'
      }
    };
  },
  methods: {
    openPopup(data) {
      this.showPopup = true;
      this.couponType = data.type;
      console.log('this.couponType', this.couponType);
      this.$emit('open');
    },
    closePopup() {
      this.showPopup = false;
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.tips-bottom-popup {
  max-height: 70vh;

  .tips-bottom-popup-wrap {
    background: #ffffff;
    border-radius: 20px 20px 0px 0px;
    max-height: 70vh;
    min-height: 100px;
    box-sizing: border-box;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;

    .tips-bottom-popup-title {
      font-size: 36px;
      color: #383838;
      letter-spacing: -1.66px;
      text-align: center;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #e6e6e6;
      height: 114px;
      position: relative;
      flex-shrink: 0;

      .close-btn {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 32px;
        object-fit: contain;
      }
    }
    .tips-bottom-popup-content {
      font-size: 32px;
      color: #646464;
      letter-spacing: -1.48px;
      font-weight: 400;
      padding: 32px;
      box-sizing: border-box;
      width: 100%;
      overflow: scroll;
      line-height: 45px;
      flex: 1;
    }
  }
}
.content {
  line-height: 2;
}
.van-popup {
  background-color: unset;
}
.flex-center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
